var map = {
	"./Abhishek.webp": 31578,
	"./Aman.webp": 56728,
	"./Anthropic-Identity_Logo_Website.webp": 66244,
	"./Avanish.webp": 66331,
	"./Beamlab-logo.webp": 60395,
	"./BlinkNow.webp": 80227,
	"./CAB.webp": 72637,
	"./Darshan.webp": 64140,
	"./Digu_Logo_Primary.webp": 81037,
	"./Digu_Logo_White.webp": 76274,
	"./Job-placement_neu.webp": 51401,
	"./Okta.webp": 1200,
	"./Sudhir.webp": 91514,
	"./Sunbid.webp": 92188,
	"./a-secure-and-productive-work-environment.webp": 30068,
	"./about-hero.webp": 15785,
	"./about-hero@2x.webp": 36089,
	"./about-hero@3x.webp": 17548,
	"./about-mission.webp": 5833,
	"./about-mission@2x.webp": 85945,
	"./about-mission@3x.webp": 35724,
	"./about-vision.webp": 35641,
	"./about-vision@2x.webp": 25641,
	"./about-vision@3x.webp": 36028,
	"./accelerated-time-to-market.webp": 45359,
	"./ankit_kumar_sha.webp": 44496,
	"./anwesh_dahal.webp": 12450,
	"./bishesh_dangol.webp": 10357,
	"./cares-hero.webp": 34832,
	"./coder_level_1.webp": 99523,
	"./communicator.webp": 96802,
	"./compeititve-salaries-and-enhanced-living-standards.webp": 14867,
	"./cost-effective-solutions.webp": 66493,
	"./creative_specialist.webp": 85652,
	"./developer-section-bg.webp": 62429,
	"./development.webp": 41606,
	"./effort-less-payroll-and-compliance.webp": 77673,
	"./empowering-your-career-trajectory.webp": 23189,
	"./flexible-scalability.webp": 17656,
	"./for-developers-hero.webp": 75847,
	"./for-developers-hero@2x.webp": 96959,
	"./for-developers-hero@3x.webp": 59642,
	"./for-hiring-companies-hero.webp": 73463,
	"./for-hiring-companies-hero@2x.webp": 96655,
	"./for-hiring-companies-hero@3x.webp": 46858,
	"./hari_roka.webp": 90567,
	"./hiring-company-section-bg.webp": 8128,
	"./home-big-data.webp": 31200,
	"./home-cloud.webp": 86126,
	"./home-custom-software-development.webp": 64812,
	"./home-hero.webp": 76497,
	"./home-hero@2x.webp": 11073,
	"./home-hero@3x.webp": 62100,
	"./home-mobile-and-web.webp": 40188,
	"./home-third-party.webp": 54623,
	"./home-why-we-exist.webp": 794,
	"./home-why-we-exist@2x.webp": 29704,
	"./home-why-we-exist@3x.webp": 16389,
	"./home-why-we-exist_.webp": 36419,
	"./home_why-we-exist_neu.webp": 13887,
	"./james_bonifield.webp": 40798,
	"./job-placement-hero-2.webp": 76078,
	"./job-placement-hero.webp": 77573,
	"./ktm.webp": 64889,
	"./nischal_shakya.webp": 86469,
	"./programs-section.webp": 89822,
	"./project-management.webp": 97086,
	"./project_leader.webp": 13229,
	"./round-the-clock-availability.webp": 53714,
	"./rubin_maharjan.webp": 79972,
	"./ryan_schultz.webp": 84421,
	"./ryan_schultz_old.webp": 15823,
	"./san-diego.webp": 8964,
	"./service-dsaas-one.webp": 39616,
	"./service-dsaas-one@2x.webp": 25238,
	"./service-dsaas-one@3x.webp": 40395,
	"./service-dsaas-three.webp": 57148,
	"./service-dsaas-three@2x.webp": 17034,
	"./service-dsaas-three@3x.webp": 9359,
	"./service-sdaas-one.webp": 88334,
	"./service-sdaas-one@2x.webp": 64324,
	"./service-sdaas-one@3x.webp": 785,
	"./service-sdaas-three.webp": 30150,
	"./service-sdaas-three@2x.webp": 8188,
	"./service-sdaas-three@3x.webp": 10633,
	"./service-sdaas-two.webp": 31744,
	"./service-sdaas-two@2x.webp": 93622,
	"./service-sdaas-two@3x.webp": 42955,
	"./shirish_parajuli.webp": 11268,
	"./smartworks-cares-carousel-slide-one.webp": 12253,
	"./smartworks-cares-carousel-slide-one@2x.webp": 32453,
	"./smartworks-cares-carousel-slide-one@3x.webp": 4296,
	"./smartworks-cares-carousel-slide-three.webp": 70621,
	"./smartworks-cares-carousel-slide-two.webp": 79907,
	"./smartworks-central-carousel-slide-four.webp": 85756,
	"./smartworks-central-carousel-slide-four@2x.webp": 1578,
	"./smartworks-central-carousel-slide-four@3x.webp": 77551,
	"./smartworks-central-carousel-slide-one.webp": 60252,
	"./smartworks-central-carousel-slide-one@2x.webp": 44906,
	"./smartworks-central-carousel-slide-one@3x.webp": 89647,
	"./smartworks-central-carousel-slide-three.webp": 96248,
	"./smartworks-central-carousel-slide-three@2x.webp": 65198,
	"./smartworks-central-carousel-slide-three@3x.webp": 68707,
	"./smartworks-central-carousel-slide-two.webp": 2862,
	"./smartworks-central-carousel-slide-two@2x.webp": 46756,
	"./smartworks-central-carousel-slide-two@3x.webp": 81265,
	"./smartworks-central-hero-image.webp": 64799,
	"./smartworks-central-hero.webp": 66779,
	"./smartworks-central-hero@2x.webp": 82187,
	"./smartworks-central-hero@3x.webp": 49206,
	"./smartworks-logo.webp": 85548,
	"./streamlined-recruitment-process.webp": 10310,
	"./swtp-badges_Coder.webp": 49432,
	"./swtp-badges_Communicator.webp": 54724,
	"./swtp-badges_Interview.webp": 94194,
	"./temp/smartworks-cares-carousel-slide-three.webp": 64598,
	"./temp/swtp-badges_Coder.webp": 81155,
	"./temp/swtp-badges_Communicator.webp": 38105,
	"./temp/swtp-badges_Interview.webp": 75329,
	"./udbodh_shrestha.webp": 59994,
	"./ujjwal_raja_maharjan.webp": 79544,
	"./unlocking-opportunities-with-top-global-innovators.webp": 89144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72066;